import { render, staticRenderFns } from "./help_content_two.vue?vue&type=template&id=30a4c466&scoped=true&"
import script from "./help_content_two.vue?vue&type=script&lang=js&"
export * from "./help_content_two.vue?vue&type=script&lang=js&"
import style0 from "./help_content_two.vue?vue&type=style&index=0&id=30a4c466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a4c466",
  null
  
)

export default component.exports